import UserApi from "api/userApi";
import * as types from "../actionTypes";
import { sendHttpRequest } from "./httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadUserInfo() {
  return async (dispatch, getState) => {
    let userInfo = getState().userInfo;
    if (userInfo.isLoaded || userInfo.loading) return;

    try {
      dispatch({ type: types.LOAD_USER_INFO_STARTED });
      userInfo = await dispatch(sendHttpRequest(UserApi.loadUserInfo()));
      dispatch({ type: types.LOAD_USER_INFO_SUCCESS, payload: userInfo });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function resetUserCache() {
  return async dispatch => {
    try {
      await dispatch(sendHttpRequest(UserApi.resetUserCache()));
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
